import Keycloak from 'keycloak-js';

let keycloakClient = null;
let authInitPromise = null;

export function getQueryParam(param, locationObj = window.location) {
  if (!locationObj) {
    return null;
  }

  let queryParams = new URLSearchParams(locationObj.search || '');
  if (queryParams.has(param)) {
    return queryParams.get(param);
  }

  const hash = locationObj.hash || '';
  if (hash.includes('?')) {
    const queryString = hash.split('?')[1];
    if (queryString) {
      queryParams = new URLSearchParams(queryString);
      if (queryParams.has(param)) {
        return queryParams.get(param);
      }
    }
  }

  return null;
}

export function getTemporaryAccessToken(locationObj = window.location) {
  return getQueryParam('access_token', locationObj);
}

export function attachTemporaryTokenMetadata(keycloak, locationObj = window.location) {
  const temporaryToken = getTemporaryAccessToken(locationObj);
  keycloak.hasTemporaryToken = !!temporaryToken;
  keycloak.temporaryToken = temporaryToken;
  return keycloak;
}

export function createKeycloakClient() {
  const client = new Keycloak({
    url: `${window.location.origin}/iam`,
    realm: 'vidapath',
    clientId: 'core',
    enableLogging: process.env.NODE_ENV !== 'production'
  });

  return attachTemporaryTokenMetadata(client);
}

export function getKeycloakClient() {
  if (!keycloakClient) {
    keycloakClient = createKeycloakClient();
  }

  return keycloakClient;
}

export function initializeAuth(keycloak = getKeycloakClient()) {
  if (!authInitPromise) {
    authInitPromise = keycloak
      .init({
        onLoad: keycloak.hasTemporaryToken ? 'check-sso' : 'login-required'
      })
      .catch(error => {
        authInitPromise = null;
        throw error;
      });
  }

  return authInitPromise;
}
